module.exports = __webpack_public_path__ + "img/V66.9aa122c2.jpg";